import theme from '../../../../../lib/theme';

const {
  layouts,
  colors,
  scale,
  media,
  font: { families, heights, spacings, ...font },
} = theme;

export default () => ({
  container: {
    ...layouts.column,
    backgroundColor: '#ffeffa',

    alignItems: 'center',
    padding: `${scale.s} ${scale.xs} ${scale.l}`,
  },

  button: {},
});
